import React from "react";
import "./BaseLoaderComponent.css";
import LoaderMini from "../LoaderMini/LoaderMini";
import { AppContext } from "../../context/AppContext";

interface IBaseLoaderComponentState {
  isInitialized: boolean;
}

export interface IBaseLoaderComponentProps {
  pageId: string;
}

const BaseLoaderComponent = <P extends IBaseLoaderComponentProps>(
  Component: React.ComponentType<P>
) =>
  class WrappedComponent extends React.Component<
    P,
    IBaseLoaderComponentState> {
    static contextType = AppContext;
    context!: React.ContextType<typeof AppContext>

    constructor(props: P) {
      super(props);

      this.state = { isInitialized: false };
    }

    componentDidMount() {
      this.setState({ isInitialized: true });
    }

    triggerLoading = () => {
      this.context.loadedChanged(true, this.props.pageId);
    }

    render() {
      let isLoading = this.state.isInitialized
        && this.context.activePage === this.props.pageId
        && this.context.isLoading
      return (
        <div
          className="nav-item nav-item-link">
          <div
            className={isLoading
              ? "component-shown"
              : "component-hidden"}>
            <LoaderMini />
          </div>

          <div
            className={isLoading
              ? "component-hidden"
              : "component-shown"}
            onClick={() => this.triggerLoading()}>
            <Component
              {...this.props as P} />
          </div>
        </div>
      );
    }
  };

export default BaseLoaderComponent;
